(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4680],{

/***/ 64680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Footer005": function() { return /* binding */ Footer005; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51712);
/* harmony import */ var components_SocialSharing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96352);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87900);
/* harmony import */ var _Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82460);
/* harmony import */ var _Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Footer005 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Footer__WEBPACK_IMPORTED_MODULE_1__/* .FooterWidgetWrapper */ .b, {
        className: (_Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[template],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4___default().block),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading5 */ .by, {
                    className: (_Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    color: "dark",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialSharing__WEBPACK_IMPORTED_MODULE_2__/* .SocialSharing */ .e, {
                    inline: true,
                    appearance: "brand",
                    buttonClassName: (_Footer005_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer005);


/***/ }),

/***/ 82460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer005_grey__CiIff","light":"Footer005_light__39Q61","block":"Footer005_block__fwwvn","button":"Footer005_button___rdaX","title":"Footer005_title__5g0xE"};

/***/ })

}]);